/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.features.Footer';

export default defineMessages({
  siteServicesHeader: {
    id: `${scope}.siteServicesHeader`,
    defaultMessage: 'Site Services',
  },
  termsOfServiceLink: {
    id: `${scope}.termsOfServiceLink`,
    defaultMessage: 'Terms of Service',
  },
  privacyLink: {
    id: `${scope}.privacyLink`,
    defaultMessage: 'Privacy Notice',
  },
  cookieLink: {
    id: `${scope}.cookieLink`,
    defaultMessage: 'Cookie Notice',
  },
  contactUsMessage: {
    id: `${scope}.contactUsMessage`,
    defaultMessage:
      'ParametaSupport@tpicap.com?Subject=Parameta%20Trading%20Analytics%20Inquiry',
  },
  siteMapLink: {
    id: `${scope}.siteMapLink`,
    defaultMessage: 'Site Map',
  },
  rssFeedLink: {
    id: `${scope}.rssFeedLink`,
    defaultMessage: 'RSS Feed',
  },
  accessibilityLink: {
    id: `${scope}.accessibilityLink`,
    defaultMessage: 'Accessibility',
  },
  rssFeed: {
    id: `${scope}.rssFeed`,
    defaultMessage: 'RSS Feed',
  },
  contactUsLink: {
    id: `${scope}.contactUsLink`,
    defaultMessage: 'Contact Us',
  },
  legalRegHeader: {
    id: `${scope}.legalRegHeader`,
    defaultMessage: 'Legal and Regulatory',
  },
  touLink: {
    id: `${scope}.touLink`,
    defaultMessage: 'Terms of Use',
  },
  legalRegulatoryTou: {
    id: `${scope}.legalRegulatoryTou`,
    defaultMessage: 'Legal & Regulatory Terms of Use',
  },
  disclaimerLink: {
    id: `${scope}.disclaimerLink`,
    defaultMessage: 'Disclaimer',
  },
  slaveryStatementLink: {
    id: `${scope}.slaveryStatementLink`,
    defaultMessage: 'Modern Slavery Statement',
  },
  membershipsLink: {
    id: `${scope}.membershipsLink`,
    defaultMessage: 'Memberships',
  },
  copyright: {
    id: `${scope}.copyright`,
    defaultMessage: `Data led solutions by TP ICAP. Copyright © ${new Date().getFullYear()} Parameta Solutions`,
  },
  brexit: {
    id: `${scope}.brexit`,
    defaultMessage: 'Brexit Information',
  },
  pension: {
    id: `${scope}.pension`,
    defaultMessage:
      'Occupational Pension Schemes (Administration And Disclosure) Regulations 2018',
  },
});
